
import React from 'react';
import { Auto } from 'fw/forms';
import * as API from 'modules/app/API'

class ZipCodeAuto extends React.Component {

	// Public
	setValue = (value) => { this._input.setValue(value); }
	getValue = () => { this._input.getValue(); }
	focus = () => { this._input.focus(); }
	select = () => { this._input.select(); }
	flag = (status) => { this._input.flag(status); }
	completed = () => { return this._input.completed(); }
	validate = () => { return this._input.validate(); }

	zipCodeLoader = () => {
		return {
			url: API.App.url('/lookup/lookupZipCode'),
			params: {
				zipCodeId: this.props.zipCodeId
			}
		}
	}

	render() {
		return (
			<Auto
				{...this.props}
				menuWidth="400px"
				loader={this.zipCodeLoader}
				placeholder={this.props.placeholder}
				ref={(input) => { this._input = input}} />
		)
	}
}

export default ZipCodeAuto;

// Mark this as a form component
ZipCodeAuto.defaultProps = {
	formControl: true,
	managed: false,
	placeholder: "Search..."
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/zipCodeAuto/ZipCodeAuto.js